import { TemplateMainMenuFieldDto } from "@domain/project/template/property/general/mainMenu/template-main-menu-field.dto";
import { Type } from "class-transformer";
import { IsOptional } from "class-validator";

export class TemplateMainMenuDto {
  @IsOptional()
  @Type(() => TemplateMainMenuFieldDto)
  newProject?: TemplateMainMenuFieldDto;
}
